import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

var StockData = function StockData(open, high, low, close, reversedInput) {
  _classCallCheck(this, StockData);

  this.open = open;
  this.high = high;
  this.low = low;
  this.close = close;
  this.reversedInput = reversedInput;
};

export { StockData as default };
export var CandleData = function CandleData() {
  _classCallCheck(this, CandleData);
};
export var CandleList = function CandleList() {
  _classCallCheck(this, CandleList);

  this.open = [];
  this.high = [];
  this.low = [];
  this.close = [];
  this.volume = [];
  this.timestamp = [];
};